export class CargueFile{

    public nombreFile : string;
    public base64file : string;
    public idticket : number;
    public tipoAdjunto : number;
    public extensionFile : string;
    

}